import {Button, Card, Modal, Space, Typography} from 'antd'
import { FC, useEffect, useState } from 'react'
import * as API_USER from '../../shared/http/user'
import {CheckCircleTwoTone, MailOutlined} from '@ant-design/icons'

interface SuccessRegistrationModalProps {
    isVisibleSuccessModal: boolean,
    closeSuccessModal: () => void,
    registeredUserEmail: string,
    containerId: string
}

const { Paragraph, Text } = Typography

export const SuccessRegistrationModal: FC<SuccessRegistrationModalProps> = ({
                                                                                isVisibleSuccessModal,
                                                                                closeSuccessModal,
                                                                                registeredUserEmail,
                                                                                containerId
                                                                            }) => {

    const [timer, setTimer] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const handleResend = () => {
        sendVerificationEmailRepeated(registeredUserEmail);
        setTimer(60);
    };

    const sendVerificationEmailRepeated = (email: string) => {
        API_USER.sendVerificationEmailRepeated(email)
    }

    return (
        <Modal
            title={
                <Space>
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                    <span>Регистрация прошла успешно!</span>
                </Space>
            }
            centered
            destroyOnClose
            open={isVisibleSuccessModal}
            okText="Сообщение пришло"
            onCancel={closeSuccessModal}
            onOk={closeSuccessModal}
            getContainer={() => document.querySelector(`#${containerId}`) as HTMLElement}
            cancelButtonProps={{ style: { display: "none" } }}
        >
            <Card bordered={false} style={{ background: "var(--color-bg-elevated)", borderRadius: 12 }}>
                <Paragraph>
                    <Text>
                        <MailOutlined /> Сообщение с подтверждением выслано вам на почту:
                    </Text>{" "}
                    <Text type="secondary">{registeredUserEmail}</Text>
                </Paragraph>

                <Button
                    type="primary"
                    block
                    onClick={handleResend}
                    disabled={timer > 0}
                >
                    {timer > 0 ? `Отправить повторно (${timer}с)` : "Отправить повторно"}
                </Button>
            </Card>
        </Modal>
    )
}